import { sapApi } from "@/apis/interceptor"
import { IGetEmployeeByIdParams, IResponse, ISapAsset, ISapAssetDto, ISapAssetPreview, ISapAssetResponseData, ISapAssetUpdateDto } from "@/types"

export const sapAssetsService = {
  getSapAssets: async (params: IGetEmployeeByIdParams): Promise<IResponse<ISapAssetResponseData>> => {
    const response = await sapApi.get<IResponse<ISapAssetResponseData>>("/api/v1/assets/history", { params })
    return response.data
  },

  getSapAssetByRecordId: async (recordId: string): Promise<IResponse<ISapAsset>> => {
    const response = await sapApi.get<IResponse<ISapAsset>>(`/api/v1/assets/${recordId}`)
    return response.data
  },

  createSapAsset: async (dto: ISapAssetDto): Promise<ISapAsset> => {
    const response = await sapApi.post<ISapAsset>("/api/v1/assets", dto)
    return response.data
  },

  updateSapAsset: async (recordId: string, dto: ISapAssetUpdateDto): Promise<ISapAsset> => {
    const response = await sapApi.patch<ISapAsset>(`/api/v1/assets/${recordId}`, dto)
    return response.data
  },

  previewAsset: async (file: File): Promise<IResponse<ISapAssetPreview>> => {
    const formData = new FormData()
    formData.append("file", file)

    const response = await sapApi.post<IResponse<ISapAssetPreview>>("/api/v1/assets/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },
}
